import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBzuz_rryqaYLDcdxf_d4MI9KRHJnUi7Hg",
  authDomain: "test-36c7c.firebaseapp.com",
  projectId: "test-36c7c",
  storageBucket: "test-36c7c.firebasestorage.app",
  messagingSenderId: "802312313047",
  appId: "1:802312313047:web:f9d0e9363f3020d0f2f892",
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const db = getFirestore(app);
